// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5589ff51","455":"32ac18eb","977":"1746e28e"}[chunkId] + ".chunk.js";
};